export default __webpack_public_path__ + "static/media/carousel_avater3.35936708.png";